import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";
import ProgressBar from "@/components/ProgressBar.vue";
import { Module } from "@/store/enums.ts";

@Component
export default class SideMenu extends Vue {
  @Prop() module!: Module;
  activeModule: Module | any = Module.BALLI;
  selected: any = null;
  baliTasks: any = null;
  balaTasks: any = null;
  ttmjTasks: any = null;

  constructor() {
    super();
    this.baliTasks = this.$store.getters.balliSections;
    this.balaTasks = this.$store.getters.balaSections;
    this.ttmjTasks = this.$store.getters.ttmjSections;
  }

  beforeCreate() {
    this.baliTasks = this.$store.getters.balliSections;
    this.balaTasks = this.$store.getters.balaSections;
    this.ttmjTasks = this.$store.getters.ttmjSections;
  }

  beforeMount() {
    if (this.$route.path.includes("bala")) {
      this.activeModule = Module.BALA;
    } else if (this.$route.path.includes("talk2mejr")) {
      this.activeModule = Module.TTMJ;
    } else {
      this.activeModule = Module.BALLI;
    }
  }

  private balliContent() {
    return (
      <div>
        {this.baliTasks.map((object: any) => (
          <v-list-item
            onClick={() => {
              this.$router.push(object.path);
            }}
          >
            <v-list-item-content>
              <v-list-item-title>{object.name}</v-list-item-title>
              <v-progress-linear
                value={object.progress}
                color="primary"
              ></v-progress-linear>
            </v-list-item-content>
          </v-list-item>
        ))}
      </div>
    );
  }

  private balaContent() {
    let title = function(i: any, object: any) {
      if (i == 6 || i == 0)
        return "shortName" in object ? object.shortName : object.name;
      if (i > 6) i -= 6;
      return "shortName" in object
        ? `${i}. ${object.shortName}`
        : `${i}. ${object.name}`;
    };

    return (
      <div>
        {this.balaTasks.map((object: any, i: number) => (
          <v-list-item
            onClick={() => {
              this.$router.push(object.path);
            }}
          >
            <v-list-item-content>
              <v-list-item-title>{title(i, object)}</v-list-item-title>
              <v-progress-linear
                value={object.progress}
                color="primary"
              ></v-progress-linear>
            </v-list-item-content>
          </v-list-item>
        ))}
      </div>
    );
  }

  private TTMJContent() {
    return (
      <div>
        {this.ttmjTasks.map((object: any) => (
          <v-list-item
            onClick={() => {
              this.$router.push(object.path);
            }}
          >
            <v-list-item-content>
              <v-list-item-title>{object.name}</v-list-item-title>
              <v-progress-linear
                value={object.progress}
                color="primary"
              ></v-progress-linear>
            </v-list-item-content>
          </v-list-item>
        ))}
      </div>
    );
  }

  render(h: CreateElement) {
    return (
      <v-navigation-drawer app permanent clipped>
        <v-list-item
          onClick={() => {
            this.$router.push("/home");
          }}
        >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item
          onClick={() => {
            this.activeModule =
              this.activeModule == Module.BALLI ? null : Module.BALLI;
          }}
          active-class="dark-purple"
        >
          <v-list-item-icon>
            <v-img
              src={require("@/assets/balli.png")}
              style={{ width: "30px" }}
            ></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>BALLI</v-list-item-title>
            <v-progress-linear
              value={Math.round(
                (this.$store.getters.progressBalli /
                  this.$store.getters.numBalliQuestions) *
                  100
              )}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </v-list-item-content>
        </v-list-item>
        {this.activeModule == Module.BALLI ? this.balliContent() : ""}
        <v-list-item
          onClick={() => {
            this.activeModule =
              this.activeModule == Module.BALA ? null : Module.BALA;
          }}
          active-class="dark-purple"
        >
          <v-list-item-icon>
            <v-img
              src={require("@/assets/bala.png")}
              style={{ width: "30px" }}
            ></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>BALA</v-list-item-title>
            <v-progress-linear
              value={Math.round(this.$store.getters.progressBala)}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </v-list-item-content>
        </v-list-item>
        {this.activeModule == Module.BALA ? this.balaContent() : ""}
        <v-list-item
          onClick={() => {
            this.activeModule =
              this.activeModule == Module.TTMJ ? null : Module.TTMJ;
          }}
          active-class="dark-purple"
        >
          <v-list-item-icon>
            <v-img
              src={require("@/assets/talk2mejr.png")}
              style={{ width: "30px" }}
            ></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>TALK2MEJR</v-list-item-title>
            <v-progress-linear
              value={Math.round(this.$store.getters.progressTTMJ)}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </v-list-item-content>
        </v-list-item>
        {this.activeModule == Module.TTMJ ? this.TTMJContent() : ""}
      </v-navigation-drawer>
    );
  }
}

const component = SideMenu;
